/**
 * stop-watching-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tsmith@safetyweb.org>
 */

import { TypedDataHolder } from "../../../common/data/typed-data";
import { WatchlistEntry } from "../../../watchlist/watchlist-entry";
import { validateFor, validateOpaqueID } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * The {@link StopWatchingResponse} is sent to the client to confirm that a
 * resource has been removed from the user's watchlist.
 */
@validateFor(MessageTag.RSP_STOP_WATCHING)
export class StopWatchingResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_STOP_WATCHING;

  @validateOpaqueID()
  public watchId : number;

  @validateOpaqueID()
  public objectId : number;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/stop-watching-response.ts